<template>
  <div class="section-content"  v-bar>
    <div class="scroll">
      <div class="body">
        <Content :html="data.html" />
        <img v-if="data.image" class="image" :src="data.image">
        <Pagination v-if="arrows" @prev="prev" @next="next" />
      </div>
    </div>
  </div>
</template>

<script>
import Content from '../Content.vue'
import Pagination from './Pagination.vue'
import $ from "jquery";

export default {
  props: [
    'content',
    'arrows'
  ],

  components: {
    Content,
    Pagination
  },

  computed: {
    data () {
      return this.content
    }
  },

  mounted () {
    this.addEventScroll()
  },

  methods: {
    addEventScroll () {
      $(".scroll").scroll(function(e) {
        if ($(this).scrollTop() > 50) {
          $('.logo').addClass('only-img')
        } else {
          $('.logo').removeClass('only-img')
        }
      })
    },

    prev () {
      this.$emit('prev')
    },

    next () {
      this.$emit('next')
    }
  },

  watch: {
    content (val) {
      this.addEventScroll()
    }
  }
}
</script>

<style lang="scss">
.section-content {
  overflow: hidden;
  width: 100%;
  .vb-dragger {
    @media screen and (max-width: 1018px) {
      display: none;
    }
  }
  .body {
    margin-top: 180px;
    margin-bottom: 10px;
    padding-right: 80px;
    @media screen and (max-width: 1280px) {
      margin-top: 130px;
    }

    @media screen and (max-width: 1018px) {
      margin-top: 0px;
      margin-bottom: 0px;
      padding-right: 0px;
    }
  }
  &.vb-invisible {
    position: relative;
    .page-bottom {
      position: absolute;
      bottom: 40px;
      left: 0px;
    }
  }
  .scroll {
    width: calc(100% + 30px) !important;
    @media screen and (max-width: 1018px) {
      width: 100% !important;
      overflow: hidden !important;
    }
  }
  .page-bottom {
    margin-top: 40px;
  }
}
</style>